import styled from 'styled-components';

export const Container = styled.div``;

export const Content = styled.div`
  width: 100%;
  text-align: center;

  form {
    display: flex;
    margin: 1rem 0;
    flex-direction: column;

    div {
      display: flex;
      margin: 1rem 0;
      flex-direction: row-reverse;
    }

    .resetPassword {
      width: 250px;
      height: 50px;
      background: var(--orange);
      border-radius: 10px;
      transition: all 0.2s;
      &:hover {
        background: #dc5129;
      }
    }
  }
`;
